/**
 * 로그인 뒤 «원래 보던 화면» 으로 돌려보내기 — 같은 사이트 안의 주소만 허용한다.
 * ProtectedRoute 가 넘기는 React Router location({pathname, search, hash})을 받는다(엑셀 클레임 바로가기의 `?id=&openDetail=1` 유지).
 * 조금이라도 이상하면 대시보드: 역슬래시·제어문자 · 다른 origin · 한두 번 풀었을 때 `//`·`\`·`scheme:` · 깨진 `%`.
 */
export interface ReturnLocation {
  pathname: string;
  search: string;
  hash: string;
}

const DASHBOARD: ReturnLocation = { pathname: '/dashboard', search: '', hash: '' };

function looksExternal(value: string): boolean {
  return value.includes('//') || value.includes('\\') || /^\/*[a-z][a-z\d+.-]*:/i.test(value);
}

export function safeReturnLocation(from: unknown): ReturnLocation {
  if (!from || typeof from !== 'object') return DASHBOARD;
  const { pathname, search, hash } = from as Partial<Record<keyof ReturnLocation, unknown>>;
  if (typeof pathname !== 'string' || !pathname.startsWith('/')) return DASHBOARD;
  const raw = pathname + (typeof search === 'string' ? search : '') + (typeof hash === 'string' ? hash : '');
  // eslint-disable-next-line no-control-regex
  if (/[\\\u0000-\u001f\u007f]/.test(raw) || looksExternal(raw)) return DASHBOARD;

  let url: URL;
  try {
    url = new URL(raw, window.location.origin);
  } catch {
    return DASHBOARD;
  }
  if (url.origin !== window.location.origin) return DASHBOARD;

  let decoded = raw;
  for (let i = 0; i < 2; i += 1) {
    try {
      decoded = decodeURIComponent(decoded);
    } catch {
      return DASHBOARD;
    }
    if (looksExternal(decoded)) return DASHBOARD;
  }
  return { pathname: url.pathname, search: url.search, hash: url.hash };
}
